import React, { useContext, useRef, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { RotatingSquare } from "react-loader-spinner";
import { AuthContext } from "../../../Contexts/AuthContext/AuthProvider";
const DepositMethodsAdd = () => {
    const { authUser } = useContext(AuthContext);
    const [errorMessage, setErrorMessage] = useState([]);
    const [dataVulue, setDataVulue] = useState({});
    const refSubmitDis = useRef();

    const [QRCode, setQRCode] = useState("");

    const handleQRCode = (e) => {
        setQRCode(e.target.files[0]);
    };

    const handleSubmitData = (event) => {
        event.preventDefault();
        refSubmitDis.current.setAttribute("disabled", true);
        const StoreData = { ...dataVulue, QRCode };

        try {
            const config = {
                headers: {
                    "content-type": "multipart/form-data",
                },
            };
            axios
                .post(
                    `https://api.velormall.com/api/admin/deposit/method/store`,
                    StoreData,
                    config
                )
                .then((response) => {
                    event.target.reset();
                    toast.success(`${response?.data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    refSubmitDis.current.removeAttribute("disabled");
                })
                .then((data) => {
                    toast.success(`${data.message}`, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                })
                .catch((error) => {
                    setErrorMessage(error?.response?.data?.errors)
                    refSubmitDis.current.removeAttribute("disabled");
                });
        } catch (error) {

        }
    };

    const handleInputBlur = (event) => {
        const value = event.target.value;
        const field = event.target.name;
        const newData = { ...dataVulue };
        newData[field] = value;
        setDataVulue(newData);
    };

  return (
            <>
                <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
                    <h6 className="page-title">Deposit Method Add</h6>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <div className="card mb-4">
                            <form onSubmit={handleSubmitData}>
                                <div className="card-body">
                                    <div className="payment-method-item">
                                        <div className="payment-method-body">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>QR Code Image</label>
                                                        <div className="image-upload">
                                                            <div className="thumb">
                                                                <div className="avatar-edit">
                                                                    <input
                                                                        type="file"
                                                                        onChange={handleQRCode}
                                                                        className="profilePicUpload"
                                                                        name="QRCode"
                                                                        id="profilePicUpload0"
                                                                        accept=".jpg, .png, .jpeg"
                                                                    />
                                                                    <label
                                                                        htmlFor="profilePicUpload0"
                                                                        className="bg--primary"
                                                                    >
                                                                        Image
                                                                    </label>
                                                                    <small class="mt-2  ">
                                                                        Supported files: <b>jpeg, jpg, png</b>. |
                                                                        Will be resized to:
                                                                        <b>800x800</b>
                                                                        px.
                                                                    </small>
                                                                </div>
                                                                {errorMessage?.QRCode && (
                                                                    <span className="text-danger pt-2">
                                                                        {errorMessage?.QRCode?.msg}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className=" col-md-8 ">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="heading" className="required">
                                                                Network
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="network"
                                                                onBlur={handleInputBlur}
                                                                id="heading"
                                                            />
                                                        </div>
                                                        {errorMessage?.network && (
                                                            <span className="text-danger pt-2">
                                                                {errorMessage?.network?.msg}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="heading" className="required">
                                                                Wallet Address
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="wallet_address"
                                                                onBlur={handleInputBlur}
                                                                id="heading"
                                                            />
                                                        </div>
                                                        {errorMessage?.wallet_address && (
                                                            <span className="text-danger pt-2">
                                                                {errorMessage?.wallet_address?.msg}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <button
                                        type="submit"
                                        ref={refSubmitDis}
                                        className="btn btn-primary w-100 h-45"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </>
        );
};
export default DepositMethodsAdd;
